export default "/images/ecoplast.svg?de58c15c1f684a9332b31851a07c1e75";